module.exports = __webpack_public_path__ + "img/1F512.83fe6e58.svg";